import { IconProps } from "Icons/types";

export const GmailIcon = ({ width = 24, height = 24 }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30 11.6906L26.6667 13.524L23.3334 16.6906V27.5573H28C29.1047 27.5573 30 26.662 30 25.5573V11.6906Z"
      fill="#4CAF50"
    />
    <path
      d="M2 11.6906L4.40933 12.8306L8.66667 16.6906V27.5573H4C2.89533 27.5573 2 26.662 2 25.5573V11.6906Z"
      fill="#1E88E5"
    />
    <path
      d="M23.3333 8.35729L16 13.8573L8.66667 8.35729L8 12.224L8.66667 16.6906L16 22.1906L23.3333 16.6906L24 12.224L23.3333 8.35729Z"
      fill="#E53935"
    />
    <path
      d="M2 9.08929V11.6906L8.66667 16.6906V8.35729L6.584 6.79663C6.088 6.42463 5.48533 6.22396 4.86533 6.22396C3.28267 6.22396 2 7.50663 2 9.08929Z"
      fill="#C62828"
    />
    <path
      d="M30 9.08929V11.6906L23.3334 16.6906V8.35729L25.416 6.79663C25.912 6.42463 26.5147 6.22396 27.1347 6.22396C28.7174 6.22396 30 7.50663 30 9.08929Z"
      fill="#FBC02D"
    />
  </svg>
);
